import { render, staticRenderFns } from "./BillDataTable.vue?vue&type=template&id=2bc9de84&"
import script from "./BillDataTable.vue?vue&type=script&lang=js&"
export * from "./BillDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports